<template>
  <div class="app-email-i">
    <div class="ae-content-w scrollable">
      <div class="aec-head ">
                <div class="actions-left " >
                    <button class="mr-2 mb-2 btn btn-success btn-sm" type="button" @click="updateHeader()"> Update Settings</button>
                </div>
                <div class="actions-right ">
                </div>
            </div>
      <div class="ae-content pt-3" style="width: 100%">

        <div class="profile-tile">
          <div class="list-order">
            <label for="">Channel: </label>
            <select v-model="selectedChannel" @change="getRules" class="form-control form-control-sm rounded inline-block">
              <option v-for="channel in channels" :value="channel.id_channel">{{channel.channel_name}}</option>
            </select>
          </div>
        </div>
      </div>
      <Loader v-if="isLoading" />
      <div class="p-3 row" v-else>

        <div class="col-sm-4  ">
          <form id="formValidate" novalidate="true">
            <div class="element-info">
              <div class="element-info-with-icon">
                <div class="element-info-text">
                  <h5 class="element-inner-header">Naming Settings</h5>
                  <div class="element-inner-desc">These settings affect all image names
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <br>
              <label for=""> Suffix Seperator</label>
              <select class="form-control" v-model="seperator">
                <option value="~">Tilda (~)</option>
                <option value="@">At sign (@)</option>
                <option value=".">Dot (.)</option>
                <option value="-">Dash (-)</option>
                <option value="_">Underscore (_)</option>
                <option value=" ">Space</option>
                <option value="">None</option>
              </select>
            </div>
          </form>
        </div>

        <div class="table-responsive force-scrollable col-sm-8">
          <table class="table table-striped table-lightborder">
            <thead>
              <tr>
                <th>Sequence</th>
                <th>Prefix</th>
                <th>Suffix</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for='x in imageNaming'>
                <th>Image {{x.key}}</th>
                <th>IMAGE_NAME</th>

                <th class="input-search-w">
                  <input type="text" v-model="x.value" @change="processChange" class="form-control rounded bright" style="width: 80px;text-align: center;font-size: 15px;">
                </th>

              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
import CommonFunctions from '@/mixins/common-functions.js'

import Loader from '@/components/common/Loader'

export default {
  mixins: [CommonFunctions],
  components: { Loader },

  data () {
    return {
      isLoading: true,
      headers: '',
      loadingHeaders: true,
      selectedHeader: '',
      formMode: 'view',
      imageNaming: [],
      seperator: '_',
      imageNameingCache: '',
      hasChanges: false,
      channels: '',
      selectedChannel: ''
    }
  },

  mounted () {
    this.getParams()
  },
  methods: {
    getParams () {
      var self = this

      this.channels = this.$store.getters.clientChannels
      this.selectedChannel = this.channels[0].id_channel
      self.getRules()
    },
    getRules: function () {
      var self = this
      const url =
        '/orgdesk/imagerules'
      self.isLoading = true

      let data = {
        id_channel: self.selectedChannel
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.processSequence(response.data.sequence)
          self.seperator = response.data.seperator || ''
          self.isLoading = false
        })
        .catch(function (error) {
          self.isLoading = false
        })
    },
    processSequence (sequence) {
      var tempSequence = []
      if (!sequence) {
        sequence = '1,2,3,4,5,6,7,8,9,10'
      }
      sequence = sequence.split(',')
      for (let i = 0; i < 10; i++) {
        var x = sequence[i] || ''
        tempSequence.push({ key: i, value: (x).replace('_', '').toString() })
      }

      this.imageNaming = tempSequence
      this.imageNameingCache = JSON.parse(JSON.stringify(this.imageNaming))
    },
    processChange () {
      var valueArr = this.imageNaming.map(function (item) {
        return item.value
      })
      var isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx
      })

      if (isDuplicate == true) {
        alert('Duplicate values are not allowed')
        this.imageNaming = JSON.parse(JSON.stringify(this.imageNameingCache))
      } else {
        this.imageNameingCache = JSON.parse(JSON.stringify(this.imageNaming))
      }
    },
    updateHeader () {
      var self = this

      const url = '/orgdesk/imagerules/update'

      let data = {
        sequence: this.imageNaming.map(x => '_' + x.value).join(','),
        seperator: self.seperator,
        id_channel: self.selectedChannel
      }

      self.isLoading = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'Settings updated',
            show: true
          })
          self.isLoading = false
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
          self.isLoading = false
        })
    }

  },
  watch: {
    seperator () {
      this.hasChanges = true
    }
  }
}
</script>

<style scoped>
.aec-full-message-w .message-content {
  padding: 0px;
}
.property-single .property-info-w {
  padding: 0px;
}
.property-single .property-info-w .property-info-main {
  padding: 10px;
}
.property-single .property-info-w .property-section .property-section-body {
  padding: 10px 0px;
}
.ae-content {
  padding: 0px;
}
.profile-tile {
  flex-direction: row;
  justify-content: left;
  padding-left: 10px;
}
.profile-tile-box {
  margin: 5px;
}
.profile-tile .pt-avatar-w {
  border-radius: 0px;
}
.inline-block {
  display: inline-block;
}
</style>
